import { render, staticRenderFns } from "./InviteFieldTeamUser.vue?vue&type=template&id=96789cf4&scoped=true&"
import script from "./InviteFieldTeamUser.vue?vue&type=script&lang=js&"
export * from "./InviteFieldTeamUser.vue?vue&type=script&lang=js&"
import style0 from "./InviteFieldTeamUser.vue?vue&type=style&index=0&id=96789cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96789cf4",
  null
  
)

export default component.exports